import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LoadingController } from '@ionic/angular';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { saveAs } from 'file-saver';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SharedService } from 'src/app/service/shared/shared.service';

@Component({
  selector: 'app-kpitables-popup',
  templateUrl: './kpitables-popup.component.html',
  styleUrls: ['./kpitables-popup.component.scss'],
})
export class KPITablesPopupComponent implements OnInit {
  gridData: {
    columnInfo: Array<{ label: string, propertyName: string, sortingName: string }>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    currentPage: number
  } = {
      columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, currentPage: 0
    };
  renderData: any[] = [];
  paginationUrl: any = '';
  //paginationUrl: any = this.config.getAllImportHistroy;
  isChangeDetected: boolean = false;
  currentPage: number = 0;
  selectedSizeToShowData: number = 25;
  buttonName: any;
  buttonColorName: any;
  loggedInUserId: any;
  loggedInUserCompanyID: any;
  searchText: any = null;
  loggedInCompanyIndustryName: any = null;
  loggedInCompanyIndustryID: any;
  subIndustriesList: any = [];
  designationList: any = [];
  functionList: any = [];
  selectedSubIndustries: any = [];
  selectedFunction: any = [];
  selectedDesignation: any = [];
  selectedTab: any;
  selectedUserID: any;
  selectedKPIList: any = [];
  loggedInUserRole: any;
  totalWeightage: any = 0;
  totalKpiScore: any = 0;
  selectAllCheckbox: boolean = false;
  kpiDataList: any = [];
  managerID: any = null;
  userID: any = null;
  fromYear: any;
  toYear: any;
  currentPageNumberOfKpis: any = 1;
  page: any = 0;
  fromMonth: any;
  toMonth: any;
  showingCount: any = 1;
  showingOfCount: any = 0;
  previousPageTotalCount: any = 0;
  dropdownSettings: IDropdownSettings = {};
  notApprovedMonths: any = [];
  selectedMonthsForKpiAdd: any=[];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<KPITablesPopupComponent>, private fb: FormBuilder, private dialog: MatDialog,
    private config: Config, private httpService: HttpService, private loadingController: LoadingController,
    private datePipe: DatePipe, private encryptionService: EncryptionService, public sharedService: SharedService,) { }

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyIndustryName = sessionStorage.getItem('loggedInCompanyIndustryName');
    this.loggedInCompanyIndustryID = sessionStorage.getItem('loggedInCompanyIndustryID');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonName = this.data?.buttonName;
    this.selectedTab = this.data?.selectedTab;
    this.selectedUserID = this.data?.selectedUserID;
    this.fromYear = this.data?.fromYear;
    this.toYear = this.data?.toYear;
    this.fromMonth = this.data?.fromMonth,
      this.toMonth = this.data?.toMonth

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.initilaizeColumn();
    switch (this.buttonName) {
      case 'Previous Months KPI':
        this.getPMSSetUpByID();
        this.getPreviousKpis();
        this.targetNotApprovedMonths();
        break;
      case 'Reporting Manager KPI':
        this.getKpisOfReportingManager();
        break;
      case 'Company KPI':
        this.getKpisOfCompany();
        break;
      case 'Repository':
        this.getAllSubIndustriesByIndustryID();
        this.getFunctionList();
        this.getDesignationList();
        // this.getRepositoryKPIs();
        break;
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  initilaizeColumn() {
    this.gridData.columnInfo = [];
    if (this.buttonName == 'Repository') {
      this.gridData.columnInfo.push({ label: 'Function', propertyName: 'function', sortingName: 'incidentNumber' });
      this.gridData.columnInfo.push({ label: 'Designation', propertyName: 'designation', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'KPI', propertyName: 'kpi', sortingName: 'lastName' });
      this.gridData.columnInfo.push({ label: 'KRA', propertyName: 'kra', sortingName: 'doj' });
      this.gridData.columnInfo.push({ label: 'UOM', propertyName: 'uom', sortingName: 'firstName' });
    } else {
      this.gridData.columnInfo.push({ label: 'KRA', propertyName: 'kra', sortingName: 'incidentNumber' });
      this.gridData.columnInfo.push({ label: 'My KPI', propertyName: 'kpi', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Lesser is Better', propertyName: 'lesserisbetter', sortingName: 'lastName' });
      this.gridData.columnInfo.push({ label: 'Weightage (%)', propertyName: 'weightage', sortingName: 'doj' });
      this.gridData.columnInfo.push({ label: 'UOM', propertyName: 'uom', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Target', propertyName: 'target', sortingName: 'firstName' });
    }
  }
  renderColumnData(listData: any) {
    this.gridData.columnData = [];
    if (this.buttonName == 'Repository') {
      for (let i = 0; i < listData?.length; i++) {
        this.gridData.columnData.push({
          function: listData[i].empFunction,
          designation: listData[i].userDesignation,
          kpi: listData[i].kpi,
          kra: listData[i].kra,
          uom: listData[i].uom,
        });
      }
    } else {
      for (let i = 0; i < listData?.length; i++) {
        this.gridData.columnData.push({
          id: listData[i].id,
          kra: listData[i].kra,
          kpi: listData[i].kpi,
          lesserisbetter: listData[i].lesserIsBetter ? 'Yes' : 'No',
          weightage: listData[i].weightage,
          uom: listData[i].uom,
          target: listData[i].target,
        });
      }
    }
    this.isChangeDetected = !this.isChangeDetected;
    this.mapRenderData();
  }
  mapRenderData() {
    this.renderData = [];
    for (let i = 0; i < this.gridData.columnData.length; i++) {
      var output = Object.entries(this.gridData.columnData[i]).map(([key, value]) => ({ key, value }));
      this.renderData.push(output);
    }
  }
  getAllSubIndustriesByIndustryID() {
    this.httpService.callGetService(this.config.getAllSubIndustriesByIndustryID + Number(this.loggedInCompanyIndustryID),).subscribe((data: any) => {
      this.subIndustriesList = [];
      data?.data?.list.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.subIndustryName,
        }
        this.subIndustriesList.push(obj);
      });
      this.subIndustriesList = this.subIndustriesList.sort((a: any, b: any) => a.name.localeCompare(b.name));
    })
  }
  getFunctionList() {
    this.httpService.callGetService(this.config.getDepartmentList + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.functionList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.functionList.push(obj);
      });
      this.functionList = this.functionList.sort((a: any, b: any) => a.name.localeCompare(b.name));
    })
  }
  getDesignationList() {
    this.httpService.callGetService(this.config.getDesignationList + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.designationList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.designationList.push(obj);
      });
      this.designationList = this.designationList.sort((a: any, b: any) => a.name.localeCompare(b.name));
    })
  }
  getPreviousKpis() {
    const request = {
      "from": this.fromMonth,
      "fromYear": this.fromYear,
      "goalSettingId": null,
      "search": this.searchText,
      "to": this.toMonth,
      "toYear": this.toYear,
      "userId": this.selectedUserID
    }
    this.httpService.callPostService(this.config.getPreviousKpis, request).subscribe((data: any) => {
      this.kpiDataList = data?.data?.gsi;
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.currentPageNumberOfKpis = data?.data?.currentPageNumber + 1;
      this.renderColumnData(data?.data?.gsi);
      this.paginationData();
    });
  }
  getKpisOfReportingManager() {
    const request = {
      "from": this.fromMonth,
      "fromYear": this.fromYear,
      "goalSettingId": null,
      "search": this.searchText,
      "to": this.toMonth,
      "toYear": this.toYear,
      "userId": Number(this.selectedUserID)
    }
    this.httpService.callPostService(this.config.getKpisOfReportingManager + '?page=' + this.page, request).subscribe((data: any) => {
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.currentPageNumberOfKpis = data?.data?.currentPageNumber + 1;
      this.renderColumnData(data?.data?.gsi);
      this.paginationData();
    });
  }
  getKpisOfCompany() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "from": this.toMonth,
      "fromYear": this.fromYear,
      "search": this.searchText,
      "to": this.toMonth,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getKpiOfMD + '?page=' + this.page, request).subscribe((data: any) => {
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.currentPageNumberOfKpis = data?.data?.currentPageNumber + 1;
      this.renderColumnData(data?.data?.gsi);
      this.paginationData();
    });
  }
  getRepositoryKPIs() {
    const request = {
      "from": this.toMonth,
      "to": this.toMonth,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "designation": this.selectedDesignation.map((ele: { id: any; }) => ele.id),
      "function": this.selectedFunction?.map((ele: { id: any; }) => ele.id),
      "search": this.searchText,
      "subIndustryId": this.selectedSubIndustries?.map((ele: { id: any; }) => ele.id),
      "userId": this.selectedUserID
    }
    this.httpService.callPostService(this.config.getRepositoryKPIs + '?page=' + this.page, request).subscribe((data: any) => {
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.currentPageNumberOfKpis = data?.data?.currentPageNumber + 1;
      this.renderColumnData(data?.data?.gsi);
      this.paginationData();
    });
  }
  selectedRange: any = 25;
  paginationData() {
    if (this.previousPageTotalCount != this.gridData.totalCount) {
      this.showingCount = 1;
      this.showingOfCount = 0;
    }
    if (this.gridData.totalCount >= this.renderData.length) {
      if (this.selectedRange == this.renderData.length) {
        this.showingOfCount = (this.gridData.currentPage + 1) * this.selectedRange;
      } else {
        this.showingOfCount = this.showingOfCount + this.renderData.length
      }
      this.previousPageTotalCount = this.gridData.totalCount;
    }
    if (this.gridData.currentPage == 0) {
      this.showingCount = 1;
    } else {
      this.showingCount = (this.selectedRange * this.gridData.currentPage) + 1
    }
  }
  onSearch(data: any) {
    var search = ''
    this.searchText = data;
    if (data == '') {
      this.searchText = null;
      switch (this.buttonName) {
        case 'Previous Months KPI':
          this.getPreviousKpis();
          break;
        case 'Reporting Manager KPI':
          this.getKpisOfReportingManager();
          break;
        case 'Company KPI':
          this.getKpisOfCompany();
          break;
        case 'Repository':
          this.getRepositoryKPIs();
          break;
      }
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            switch (this.buttonName) {
              case 'Previous Months KPI':
                this.getPreviousKpis();
                break;
              case 'Reporting Manager KPI':
                this.getKpisOfReportingManager();
                break;
              case 'Company KPI':
                this.getKpisOfCompany();
                break;
              case 'Repository':
                this.getRepositoryKPIs();
                break;
            }
          },
            500);
        }
      },
        1500);
    }
  }
  pageNavigation(response: any) { }
  onSortAssending(data: any) { }
  onSortDesending(data: any) { }
  pageChange(data: any) { }
  previousPageKpi() {
    if (this.currentPageNumberOfKpis < 2) {
      return;
    } else {
      this.currentPageNumberOfKpis--;
      this.page--;
      switch (this.buttonName) {
        case 'Previous Months KPI':
          this.getPreviousKpis();
          break;
        case 'Reporting Manager KPI':
          this.getKpisOfReportingManager();
          break;
        case 'Company KPI':
          this.getKpisOfCompany();
          break;
        case 'Repository':
          this.getRepositoryKPIs();
          break;
      }
    }
  }
  nextPageKpi() {
    if (this.currentPageNumberOfKpis >= this.gridData.totalNoOfPages) {
      return;
    }
    if (this.currentPageNumberOfKpis == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPageNumberOfKpis++;
    switch (this.buttonName) {
      case 'Previous Months KPI':
        this.getPreviousKpis();
        break;
      case 'Reporting Manager KPI':
        this.getKpisOfReportingManager();
        break;
      case 'Company KPI':
        this.getKpisOfCompany();
        break;
      case 'Repository':
        this.getRepositoryKPIs();
        break;
    }
  }
  downloadKpis() {
    switch (this.buttonName) {
      case 'Previous Months KPI':
        this.downloadPreviousKpis();
        break;
      case 'Reporting Manager KPI':
        this.downloadKpisOfReportingManagerKpis();
        break;
      case 'Company KPI':
        this.downloadKpisOfCompany();
        break;
      case 'Repository':
        this.downloadRepositoryKPIs();
        break;
    }
  }
  downloadPreviousKpis() {
    const request = {
      "from": this.toMonth,
      "to": this.toMonth,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "goalSettingId": null,
      "search": null,
      "userId": this.selectedUserID
    }
    this.httpService.callPostService(this.config.downloadPreviousKpis, request).subscribe((data: any) => {
      saveAs(data?.fileUrl, "Previous_KPIs.xlsx");
    });
  }
  downloadKpisOfReportingManagerKpis() {
    const request = {
      "from": this.toMonth,
      "to": this.toMonth,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "goalSettingId": null,
      "search": null,
      "userId": this.selectedUserID
    }
    this.httpService.callPostService(this.config.downloadReportingManagerKpis, request).subscribe((data: any) => {
      saveAs(data?.fileUrl, "Reporting_Manager_KPIs.xlsx");
    });
  }
  downloadKpisOfCompany() {
    const request = {
      "from": this.toMonth,
      "to": this.toMonth,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "companyId": this.loggedInUserCompanyID,
      "search": null
    }
    this.httpService.callPostService(this.config.downloadCompanyKPIs, request).subscribe((data: any) => {
      saveAs(data?.fileUrl, "Company_KPIs.xlsx");
    });
  }
  downloadRepositoryKPIs() {
    const request = {
      "from": this.toMonth,
      "to": this.toMonth,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "designation": this.selectedDesignation?.map((ele: { id: any; }) => ele.id),
      "function": this.selectedFunction?.map((ele: { id: any; }) => ele.id),
      "search": this.searchText,
      "subIndustryId": this.selectedSubIndustries?.map((ele: { id: any; }) => ele.id),
      "userId": this.selectedUserID
    }
    this.httpService.callPostService(this.config.downloadRepositoryKpis, request).subscribe((data: any) => {
      saveAs(data?.fileUrl, "Repository_KPIs.xlsx");
    });
  }
  totalSelectedWtCount: any = 0;
  selectALLRecords(event: any) {
    if (event.checked) {
      this.selectedKPIList = [];
      this.selectAllCheckbox = true;
      for (let i = 0; i < this.kpiDataList.length; i++) {
        this.kpiDataList[i].checkboxCheck = true;
        this.renderData[i].checkboxCheck = true;
        this.selectedKPIList.push(this.kpiDataList[i]);
        var ids = []
        for (let j = 0; j < this.selectedKPIList.length; j++) {
          if (this.selectedKPIList[j]?.weightage) {
            ids.push(this.selectedKPIList[j].weightage)
          }
        }
        this.totalSelectedWtCount = ids.reduce((accumulator: number, ele: any) => {
          return accumulator + Number(ele);
        }, 0);
      }
    } else {
      for (let i = 0; i < this.kpiDataList.length; i++) {
        this.kpiDataList[i].checkboxCheck = false;
        this.renderData[i].checkboxCheck = false;
      }
      this.selectAllCheckbox = false;
      this.selectedKPIList = [];
      this.totalSelectedWtCount = 0;
    }
  }
  selectSingleRecord(event: any, data: any, i: number) {
    
    if (event.checked) {
      this.kpiDataList[i].checkboxCheck = true;
      this.renderData[i].checkboxCheck = true;
      this.selectedKPIList.push(data);
      var ids = []
      for (let j = 0; j < this.selectedKPIList.length; j++) {
        if (this.selectedKPIList[j][4]?.key == 'weightage') {
          ids.push(this.selectedKPIList[j]?.find((item: any) => item.key == 'weightage').value)
        }
      }
      for (let j = 0; j < this.selectedKPIList.length; j++) {
        if (this.selectedKPIList[j]?.weightage) {
          ids.push(this.selectedKPIList[j].weightage)
        }
      }
      this.totalSelectedWtCount = ids.reduce((accumulator: number, ele: any) => {
        return accumulator + Number(ele);
      }, 0);
    } else {
      this.selectAllCheckbox = false;
      this.kpiDataList[i].checkboxCheck = false;
      this.renderData[i].checkboxCheck = false;
      this.selectedKPIList.forEach((ele: any, ind: any) => {
        if (ele.checkboxCheck == false) {
          this.selectedKPIList.splice(ind, 1);
        }
      });
      var ids = []
      for (let j = 0; j < this.selectedKPIList.length; j++) {
        if (this.selectedKPIList[j][4]?.key == 'weightage') {
          ids.push(this.selectedKPIList[j]?.find((item: any) => item.key == 'weightage').value)
        }
      }
      for (let j = 0; j < this.selectedKPIList.length; j++) {
        if (this.selectedKPIList[j]?.weightage) {
          ids.push(this.selectedKPIList[j].weightage)
        }
      }
      this.totalSelectedWtCount = ids.reduce((accumulator: number, ele: any) => {
        return accumulator + Number(ele);
      }, 0);
    }
  }
  useKpiForThisMonth() {
    var ids = [];
    if (this.selectAllCheckbox == true) {
      ids = this.selectedKPIList.map((ele: { id: any; }) => ele.id)
    } else {
      for (let i = 0; i < this.selectedKPIList.length; i++) {
        ids.push(this.selectedKPIList[i].find((item: any) => item.key == 'id').value)
      }
    }
    if (ids.length != 0) {
      if (this.selectedTab == 'My Goals') {
        this.managerID = null;
        this.userID = Number(this.loggedInUserId)
      } else {
        this.managerID = this.loggedInUserId;
        this.userID = this.selectedUserID;
      }
      const request = {
        "from": this.toMonth,
        "to": this.toMonth,
        "fromYear": this.fromYear,
        "toYear": this.toYear,
        "companyId": this.loggedInUserCompanyID,
        "id": ids,
        "managerId": this.managerID,
        "userId": this.userID
      }
      this.httpService.callPostService(this.config.usePreviousKPI, request).subscribe((data: any) => {
        if (data?.success) {
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.data,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            },
          });
          successdialogRef.afterClosed().subscribe(result => {
            this.closeDialog();
          });
        } else {
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.data,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: false
            },
          });
          successdialogRef.afterClosed().subscribe(result => {
            // this.closeDialog();
          });
        }
      });
    }
  }
  selectAllSubIndusries(items: any): void {
    this.selectedSubIndustries = items;
    this.getRepositoryKPIs();
  }
  onDeSelectAllSubIndusries() {
    this.selectedSubIndustries = [];
  }
  selectAllFunctions(items: any): void {
    this.selectedFunction = items;
    this.getRepositoryKPIs();
  }
  onDeSelectAllFunctions() {
    this.selectedFunction = [];
  }
  selectAllDesignation(items: any): void {
    this.selectedDesignation = items;
    this.getRepositoryKPIs();
  }
  onDeSelectAllDesignation() {
    this.selectedDesignation = [];
  }
  goalSettingAtAllLevels: boolean = true;
  getPMSSetUpByID() {
    this.httpService.callGetService(this.config.getPMSSetUpByID + this.loggedInUserCompanyID + '/' + this.fromYear + '/' + this.toYear).subscribe((data: any) => {
      if (data?.data != null) {
        if (data?.data?.goalSettingAtllLevels) {
          this.goalSettingAtAllLevels = true;
        } else {
          if (this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin'
            || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD'
          ) {
            this.goalSettingAtAllLevels = true;
          } else {
            this.goalSettingAtAllLevels = false;
          }
        }
      }
    })
  }
  targetNotApprovedMonths() {
    const request = {
      "from": this.fromMonth,
      "fromYear": this.fromYear,
      "goalSettingId": null,
      "search": null,
      "to": this.toMonth,
      "toYear": this.toYear,
      "userId": this.selectedUserID
    }
    this.httpService.callPostService(this.config.targetNotApprovedMonths, request).subscribe((data: any) => {
      this.notApprovedMonths = [];
      data.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: this.sharedService.transform(ele)
        }
        this.notApprovedMonths.push(obj)
      })
    });
  }
  selectAllMonths(items: any): void {
    this.selectedMonthsForKpiAdd = items;
  }
  onDeSelectAllMonths() {
    this.selectedMonthsForKpiAdd = [];
  }
  copyPreviousKPI() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '30%',
      width: '30%',
      data: {
        msg: "Are you sure you want to copy these KPI's?",
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        
        var ids = [];
        if (this.selectAllCheckbox == true) {
          ids = this.selectedKPIList.map((ele: { id: any; }) => ele.id)
        } else {
          for (let j = 0; j < this.selectedKPIList.length; j++) {
            if (this.selectedKPIList[j][0]?.key == 'id') {
              ids.push(this.selectedKPIList[j]?.find((item: any) => item.key == 'id').value)
            }
          }
          for (let j = 0; j < this.selectedKPIList.length; j++) {
            if (this.selectedKPIList[j]?.id) {
              ids.push(this.selectedKPIList[j].id)
            }
          }

          // for (let i = 0; i < this.selectedKPIList.length; i++) {
          //   ids.push(this.selectedKPIList[i].find((item: any) => item.key == 'id').value)
          // }
        }
        if (ids.length != 0) {
          if (this.selectedTab == 'My Goals') {
            this.managerID = null;
            this.userID = Number(this.loggedInUserId)
          } else {
            this.managerID = this.loggedInUserId;
            this.userID = this.selectedUserID;
          }
          const request = {
            "from": this.toMonth,
            "to": this.toMonth,
            "fromYear": this.fromYear,
            "toYear": this.toYear,
            "companyId": this.loggedInUserCompanyID,
            "id": ids,
            "managerId": this.managerID,
            "userId": this.userID,
            "loggedInUserRole": this.loggedInUserRole,
            "months": this.selectedMonthsForKpiAdd.map((ele: any) => ele.id)
          }
          this.httpService.callPostService(this.config.copyPreviousKPI, request).subscribe((data: any) => {
            if (data?.success) {
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: data.data,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              successdialogRef.afterClosed().subscribe(result => {
                this.closeDialog();
              });
            } else {
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: data.data,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: false,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              successdialogRef.afterClosed().subscribe(result => {
                // this.closeDialog();
              });
            }
          });
        }
      }
    });
  }
}
